import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { executeActiveUndo } from "actions/undoHistoryActions";
import { isEditableTarget } from "utils/undo/isEditableTarget";
import { isUndoToastsEnabled } from "utils/undo/isUndoToastsEnabled";
import { resolveScopeFromRoute } from "utils/undo/scopeKeys";

export function useUndoKeyboard() {
	const dispatch = useDispatch();
	const location = useLocation();

	useEffect(() => {
		const onKeyDown = (event) => {
			if (!isUndoToastsEnabled()) {
				return;
			}

			const isUndoShortcut =
				(event.ctrlKey || event.metaKey) &&
				event.key.toLowerCase() === "z" &&
				!event.shiftKey;

			if (!isUndoShortcut) {
				return;
			}

			if (isEditableTarget(document.activeElement)) {
				return;
			}

			const scope = resolveScopeFromRoute(location);
			if (!scope) {
				return;
			}

			event.preventDefault();
			dispatch(executeActiveUndo(scope));
		};

		window.addEventListener("keydown", onKeyDown);
		return () => window.removeEventListener("keydown", onKeyDown);
	}, [dispatch, location]);
}
